import React from 'react';
import Button from '../../../components/ui/Button';

const QuickActionButtons = ({ 
  onSearchClick,
  onMessagesClick,
  onEditProfileClick 
}) => {
  return (
    <div className="bg-card rounded-xl p-4 md:p-6 shadow-warm">
      <div className="mb-4 md:mb-6">
        <h2 className="text-lg md:text-xl font-heading font-semibold mb-1">Quick Actions</h2>
        <p className="text-xs md:text-sm text-muted-foreground">
          Access key features instantly
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
        <Button
          variant="default"
          fullWidth
          iconName="Search"
          iconPosition="left"
          onClick={onSearchClick}
        >
          Discover Matches
        </Button>

        <Button
          variant="outline"
          fullWidth
          iconName="MessageCircle"
          iconPosition="left"
          onClick={onMessagesClick}
        >
          Message Center
        </Button>

        <Button
          variant="secondary"
          fullWidth
          iconName="Edit"
          iconPosition="left"
          onClick={onEditProfileClick}
        >
          Edit Profile
        </Button>
      </div>

      <div className="mt-4 md:mt-6 pt-4 md:pt-6 border-t border-border">
        <div className="grid grid-cols-2 gap-3 md:gap-4">
          <button className="flex flex-col items-center gap-2 p-3 md:p-4 rounded-lg bg-muted hover:bg-muted/80 transition-smooth">
            <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-primary/10">
              <span className="text-lg md:text-xl">🔒</span>
            </div>
            <span className="text-xs md:text-sm font-medium text-center">Privacy Settings</span>
          </button>

          <button className="flex flex-col items-center gap-2 p-3 md:p-4 rounded-lg bg-muted hover:bg-muted/80 transition-smooth">
            <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-success/10">
              <span className="text-lg md:text-xl">✓</span>
            </div>
            <span className="text-xs md:text-sm font-medium text-center">Verify Profile</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuickActionButtons;